import _ from 'lodash';
import React from 'react';
import Card from 'react-bootstrap/Card';
import FundContext from './context';
import Header from './header';
import Pane from './pane';
import Manager from './manager';
import Answer from './answer';

export default function Qanda() {
  const { state: { fund, qandas } } = React.useContext(FundContext);

  const type = _.get(fund, 'fundType.value');
  const typedList = _.filter(qandas, q => _.indexOf(q.fundTypes, type) >= 0);

  return (
    <Card>
      <Card.Header>
        <Header eventKey="qanda">Q&A</Header>
      </Card.Header>
      <Pane eventKey="qanda">
        <Card.Body>
          {!typedList.length && <p>{`There is no questions for ${type || 'the type of fund'}.`}</p>}
          {!!typedList.length && (
            <>
              <Manager />
              {typedList.map(q => <Answer key={`a-${q.questionId}`} {...q} />)}
            </>
          )}
        </Card.Body>
      </Pane>
    </Card>
  );
}
